import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatCardModule],
  template: `
    <div class="flex justify-center items-center min-h-screen bg-gray-100">
      <mat-card class="max-w-md w-full mx-4">
        <mat-card-header class="text-center">
          <mat-card-title class="flex items-center justify-center text-red-600">
            <mat-icon class="text-6xl mr-2">block</mat-icon>
            <span class="text-2xl">Acceso Denegado</span>
          </mat-card-title>
        </mat-card-header>
        
        <mat-card-content class="text-center py-6">
          <p class="text-gray-600 mb-4">
            No tienes los permisos necesarios para acceder a esta página.
          </p>
          <p class="text-sm text-gray-500">
            Si crees que esto es un error, contacta al administrador del sistema.
          </p>
        </mat-card-content>
        
        <mat-card-actions class="text-center">
          <button mat-raised-button color="primary" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Volver
          </button>
          <button mat-raised-button color="warn" (click)="goHome()" class="ml-2">
            <mat-icon>home</mat-icon>
            Ir al Inicio
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100vh;
    }
  `]
})
export class AccessDeniedComponent {
  constructor(private router: Router) {}

  goBack() {
    window.history.back();
  }

  goHome() {
    this.router.navigate(['/dashboard']);
  }
}